// ============================================================
// mock 数据层：字段名严格对齐原项目数据库表结构
// 图片统一用 $img 对应的本地素材（main.js 中已挂到 Vue 原型）
// ============================================================

// 直接引用图片资源（Vite 会处理为 URL）
import imgBadminton from '@/assets/img/badminton.jpg'
import imgBook from '@/assets/img/book.jpg'
import imgFitness from '@/assets/img/fitness.jpg'
import imgFootball from '@/assets/img/football.jpg'
import imgHeadphones from '@/assets/img/headphones.jpg'
import imgIpad from '@/assets/img/ipad.jpg'
import imgJavascript from '@/assets/img/javascript.jpg'
import imgLibrary from '@/assets/img/library.jpg'
import imgMathematics from '@/assets/img/mathematics.jpg'
import imgMemory from '@/assets/img/memory.jpg'
import imgPhoto from '@/assets/img/photo.jpg'
import imgPortrait from '@/assets/img/portrait.jpg'
import imgProgramming from '@/assets/img/programming.jpg'
import imgSsd from '@/assets/img/ssd.jpg'

const now = Date.now()
const day = 24 * 60 * 60 * 1000
const t = (daysAgo, h = 10, m = 0) => now - daysAgo * day - ((24 - h) * 60 + m) * 60 * 1000

// ---------------- 用户（user 表） ----------------
export const users = [
  {
    user_id: 'u-demo', username: 'demo', password: '123456', nickname: '郭昂',
    realname: '郭昂', studentid: '2020001001', studentcard: [imgPortrait],
    realstate: 3, avatar: imgPortrait, qq: '726647774', mail: 'demo@haha.edu.cn',
    synopsis: '信息工程学院大三学生，喜欢折腾技术，乐于帮助同学。',
    phone: '13800000001', companyname: '南昌网络有限公司', companyimg: [imgProgramming],
    companystate: 3, user_state: '1', user_createtime: t(300), activationdate: 0
  },
  {
    user_id: 'u-01', username: 'zhangwei', password: '123456', nickname: '账号1',
    realname: '张伟', studentid: '2020002002', studentcard: [imgPhoto],
    realstate: 3, avatar: imgPhoto, qq: '100200300', mail: 'zhangwei@haha.edu.cn',
    synopsis: '热爱生活，喜欢摄影与旅行。', phone: '13800000002', companyname: '', companyimg: [],
    companystate: 1, user_state: '1', user_createtime: t(280), activationdate: 0
  },
  {
    user_id: 'u-02', username: 'lina', password: '123456', nickname: '李娜',
    realname: '李娜', studentid: '2020003003', studentcard: [imgPhoto, imgMemory],
    realstate: 3, avatar: imgMemory, qq: '200300400', mail: 'lina@haha.edu.cn',
    synopsis: '外国语学院大二学生，爱看书爱运动。', phone: '13800000003', companyname: '', companyimg: [],
    companystate: 1, user_state: '1', user_createtime: t(260), activationdate: 0
  },
  {
    user_id: 'u-03', username: 'wangqiang', password: '123456', nickname: '王强',
    realname: '', studentid: '', studentcard: [], realstate: 1,
    avatar: '', qq: '300400500', mail: 'wangqiang@haha.edu.cn', synopsis: '新生，还在探索校园。',
    phone: '13800000004', companyname: '', companyimg: [], companystate: 1,
    user_state: '1', user_createtime: t(200), activationdate: 0
  },
  {
    user_id: 'u-04', username: 'chenjing', password: '123456', nickname: '陈静',
    realname: '陈静', studentid: '2020004004', studentcard: [imgFitness],
    realstate: 3, avatar: imgFitness, qq: '400500600', mail: 'chenjing@haha.edu.cn',
    synopsis: '健身爱好者，跑步打卡中。', phone: '13800000005', companyname: '', companyimg: [],
    companystate: 1, user_state: '1', user_createtime: t(180), activationdate: 0
  },
  {
    user_id: 'u-05', username: 'liuyang', password: '123456', nickname: '刘洋',
    realname: '刘洋', studentid: '2020005005', studentcard: [imgLibrary],
    realstate: 3, avatar: imgLibrary, qq: '500600700', mail: 'liuyang@haha.edu.cn',
    synopsis: '图书馆常驻人口，考研复习中。', phone: '13800000006', companyname: '', companyimg: [],
    companystate: 1, user_state: '1', user_createtime: t(160), activationdate: 0
  },
  {
    user_id: 'u-06', username: 'banzhu', password: '123456', nickname: '青蓝校园官方',
    realname: '平台运营', studentid: '0000000000', studentcard: [],
    realstate: 3, avatar: imgJavascript, qq: '000000000', mail: 'admin@haha.edu.cn',
    synopsis: '平台官方运营账号，负责发布官方信息。', phone: '13800000000', companyname: '青蓝校园',
    companyimg: [imgJavascript], companystate: 3, user_state: '1', user_createtime: t(500), activationdate: 0
  }
]

export const userMap = {}
users.forEach((u) => { userMap[u.user_id] = u })

// ---------------- 分类标签（lable 表） ----------------
export const lables = {
  '问答分类': ['学习交流', '校园生活', '失物招领', '求助互助', '学习资料'],
  '活动分类': ['文体活动', '讲座报告', '社团活动', '志愿服务', '比赛竞赛'],
  '招聘分类': ['兼职', '实习', '全职', '校园大使'],
  '文章分类': ['校园新闻', '学习经验', '生活随笔', '技术分享'],
  '二手分类': ['数码产品', '书籍教材', '生活用品', '体育器材', '其他']
}

// ---------------- 轮播图（carousel 表） ----------------
export const carousels = [
  { carousel_id: 'c1', carousel_img: imgLibrary, carousel_url: '#/newscontent/a1', carousel_title: '图书馆新馆开放通知' },
  { carousel_id: 'c2', carousel_img: imgFootball, carousel_url: '#/activitycontent/ac1', carousel_title: '秋季校园运动会报名' },
  { carousel_id: 'c3', carousel_img: imgProgramming, carousel_url: '#/jobcontent/j1', carousel_title: '校内勤工助学岗位招聘' }
]

// ---------------- 问答（help 表） ----------------
export const helps = [
  {
    help_id: 'h1', user_id: 'u-01', help_title: '昨天在三食堂遗失一本《C语言程序设计》',
    help_tag: '失物招领,三食堂', help_lable: '失物招领',
    help_content: '<p>昨天中午在三食堂二楼靠窗位置遗失一本《C语言程序设计》教材，封面有蓝色书皮，内有姓名学号。</p><p>如有捡到的同学请联系我，必有重谢！联系电话 13800000002。</p>',
    help_img: imgBook, createtime: t(2), updatetime: t(2), help_favour_num: 18, help_read_num: 156,
    help_state: 1, help_istop: 0, ispublic: 1, admin: 'admin', nickname: '账号1'
  },
  {
    help_id: 'h2', user_id: 'u-02', help_title: '求解，高数下册课后习题怎么做？',
    help_tag: '学习交流,高数', help_lable: '学习交流',
    help_content: '<p>高数下册第七章课后习题 7-3 的第 5、6 题不太会，有没有同学讲解一下思路？</p><p>可以的话一起约图书馆自习。</p>',
    help_img: imgMathematics, createtime: t(5), updatetime: t(5), help_favour_num: 4, help_read_num: 87,
    help_state: 1, help_istop: 0, ispublic: 1, admin: 'admin', nickname: '李娜'
  },
  {
    help_id: 'h3', user_id: 'u-demo', help_title: '求推荐性价比高的笔记本电脑，预算 5000',
    help_tag: '学习资料,数码', help_lable: '学习资料',
    help_content: '<p>马上要参加竞赛需要一台笔记本，预算 5000 左右，主要用来写代码和跑一些轻量级程序。</p><p>希望各位大佬推荐一下型号，附上理由更好！</p>',
    help_img: imgIpad, createtime: t(8), updatetime: t(8), help_favour_num: 32, help_read_num: 421,
    help_state: 1, help_istop: 1, ispublic: 1, admin: 'admin', nickname: '郭昂'
  },
  {
    help_id: 'h4', user_id: 'u-04', help_title: '羽毛球搭子招募，周末球馆约起',
    help_tag: '校园生活,运动', help_lable: '校园生活',
    help_content: '<p>每周六下午 2-4 点在校体育馆打羽毛球，目前固定 4 人，再找 2-3 个水平差不多的球友。</p><p>球馆费用 AA，欢迎报名！</p>',
    help_img: imgBadminton, createtime: t(10), updatetime: t(10), help_favour_num: 12, help_read_num: 98,
    help_state: 1, help_istop: 0, ispublic: 1, admin: 'admin', nickname: '陈静'
  },
  {
    help_id: 'h5', user_id: 'u-05', help_title: '考研英语单词书转让（全新）',
    help_tag: '二手,学习资料', help_lable: '学习资料',
    help_content: '<p>去年买的考研英语红宝书，几乎全新，附赠真题卷。10 元出，可小刀。</p><p>有需要的同学私聊。</p>',
    help_img: imgBook, createtime: t(15), updatetime: t(15), help_favour_num: 6, help_read_num: 54,
    help_state: 1, help_istop: 0, ispublic: 1, admin: 'admin', nickname: '刘洋'
  },
  {
    help_id: 'h6', user_id: 'u-03', help_title: '请问校园卡丢了去哪里补办？',
    help_tag: '校园生活,求助', help_lable: '求助互助',
    help_content: '<p>校园卡不小心弄丢了，请问补办流程是什么？需要带什么证件吗？</p><p>在线等，挺急的。</p>',
    help_img: imgMemory, createtime: t(20), updatetime: t(20), help_favour_num: 2, help_read_num: 63,
    help_state: 1, help_istop: 0, ispublic: 1, admin: 'admin', nickname: '王强'
  },
  {
    help_id: 'h7', user_id: 'u-demo', help_title: '【待审核示例】想组建一个编程学习小组',
    help_tag: '学习交流', help_lable: '学习交流',
    help_content: '<p>打算组建一个 5 人左右的编程学习小组，每周交流一次，互相督促刷题做项目。</p><p>此条为待审核状态示例数据。</p>',
    help_img: imgProgramming, createtime: t(1), updatetime: t(1), help_favour_num: 0, help_read_num: 0,
    help_state: 0, help_istop: 0, ispublic: 0, admin: '', nickname: '郭昂'
  }
]

// ---------------- 活动（activity 表） ----------------
export const activities = [
  {
    activity_id: 'ac1', user_id: 'u-06', activity_title: '秋季校园运动会报名开启',
    activity_lable: '比赛竞赛', activity_type: '线下', activity_locale: '校田径场',
    activity_content: '<p>一年一度的秋季校园运动会开始报名啦！</p><p>项目包括：100 米、400 米、跳远、铅球、接力赛等，欢迎同学们踊跃报名，为学院争光。</p>',
    activity_img: imgFootball, createtime: t(3), activity_statetime: t(-2, 9), activity_endtime: t(-2, 17),
    updatetime: t(3), activity_favour_num: 45, activity_num: 128, activity_read_num: 1024,
    activity_state: 1, activity_istop: 1, ispublic: 1, admin: 'admin', activity_impose: 'false',
    nickname: '青蓝校园官方'
  },
  {
    activity_id: 'ac2', user_id: 'u-06', activity_title: '考研经验分享讲座（第三期）',
    activity_lable: '讲座报告', activity_type: '线上', activity_locale: '线上直播（腾讯会议）',
    activity_content: '<p>邀请上岸学长学姐分享考研规划、院校选择、复习方法等经验。</p><p>会议号将在活动前发到通知中心，请报名的同学留意。</p>',
    activity_img: imgLibrary, createtime: t(6), activity_statetime: t(1, 19), activity_endtime: t(1, 21),
    updatetime: t(6), activity_favour_num: 67, activity_num: 200, activity_read_num: 1532,
    activity_state: 1, activity_istop: 0, ispublic: 1, admin: 'admin', activity_impose: 'true',
    nickname: '青蓝校园官方'
  },
  {
    activity_id: 'ac3', user_id: 'u-01', activity_title: '周末爬山活动：登顶望江亭',
    activity_lable: '文体活动', activity_type: '线下', activity_locale: '学校北门集合',
    activity_content: '<p>周末天气不错，组织一次爬山活动。路线：北门 - 望江亭 - 原路返回，全程约 3 小时。</p><p>自备水和零食，注意安全。</p>',
    activity_img: imgFitness, createtime: t(9), activity_statetime: t(3, 8), activity_endtime: t(3, 12),
    updatetime: t(9), activity_favour_num: 23, activity_num: 15, activity_read_num: 234,
    activity_state: 1, activity_istop: 0, ispublic: 1, admin: 'admin', activity_impose: 'false',
    nickname: '账号1'
  },
  {
    activity_id: 'ac4', user_id: 'u-02', activity_title: '英语角：每周五晚不见不散',
    activity_lable: '社团活动', activity_type: '线下', activity_locale: '外语楼 203 教室',
    activity_content: '<p>英语角活动持续进行中，本周主题：My Favorite Book。</p><p>欢迎各专业同学参加，外教也会到场指导。</p>',
    activity_img: imgJavascript, createtime: t(12), activity_statetime: t(4, 19), activity_endtime: t(4, 21),
    updatetime: t(12), activity_favour_num: 34, activity_num: 30, activity_read_num: 356,
    activity_state: 1, activity_istop: 0, ispublic: 1, admin: 'admin', activity_impose: 'true',
    nickname: '李娜'
  },
  {
    activity_id: 'ac5', user_id: 'u-04', activity_title: '校园公益献血活动',
    activity_lable: '志愿服务', activity_type: '线下', activity_locale: '校医院门前广场',
    activity_content: '<p>联合市中心血站开展无偿献血活动，献血 200ml 及以上可加志愿时长。</p><p>请携带身份证，注意前一天休息好。</p>',
    activity_img: imgFootball, createtime: t(18), activity_statetime: t(6, 9), activity_endtime: t(6, 16),
    updatetime: t(18), activity_favour_num: 58, activity_num: 100, activity_read_num: 876,
    activity_state: 1, activity_istop: 0, ispublic: 1, admin: 'admin', activity_impose: 'true',
    nickname: '陈静'
  }
]

// ---------------- 公司（company 表） ----------------
export const companies = [
  {
    company_id: 'cp1', user_id: 'u-06', company_name: '青蓝校园', company_scale: '50-100人',
    company_content: '<p>青蓝校园是服务于全校师生的信息发布与交流平台，提供校园资讯、二手交易、招聘信息等服务。</p>',
    company_createtime: t(300), company_updatetime: t(300), company_favour_num: 120,
    company_read_num: 5210, company_state: 1, company_istop: 1, company_ispublic: 1, company_mail: 'hr@haha.edu.cn',
    nickname: '青蓝校园官方'
  },
  {
    company_id: 'cp2', user_id: 'u-demo', company_name: '南昌网络有限公司', company_scale: '100-500人',
    company_content: '<p>南昌网络有限公司是一家专注互联网技术研发的企业，主营业务包括 Web 开发、移动应用、大数据分析等，常年面向高校招聘实习生。</p>',
    company_createtime: t(200), company_updatetime: t(100), company_favour_num: 45,
    company_read_num: 1876, company_state: 1, company_istop: 0, company_ispublic: 1, company_mail: 'hr@ncnet.com',
    nickname: '郭昂'
  },
  {
    company_id: 'cp3', user_id: 'u-02', company_name: '星火教育培训学校', company_scale: '50人以下',
    company_content: '<p>星火教育专注于中小学课外辅导，在本地拥有多家校区，教学环境优良，欢迎师范类专业同学兼职任教。</p>',
    company_createtime: t(150), company_updatetime: t(150), company_favour_num: 12,
    company_read_num: 654, company_state: 1, company_istop: 0, company_ispublic: 1, company_mail: 'hr@xinghuo.com',
    nickname: '李娜'
  }
]

// ---------------- 岗位（job 表） ----------------
export const jobs = [
  {
    job_id: 'j1', user_id: 'u-06', company_id: 'cp1', job_name: '校园内容运营助理',
    job_salary: '100元/天', job_num: '5', job_lable: '兼职',
    job_content: '<p>协助平台运营校园内容：审核稿件、整理资讯、维护社群。每周工作 2-3 天，时间灵活。</p><p>要求：细心负责，有新媒体经验者优先。</p>',
    job_createtime: t(3), job_updatetime: t(3), job_favour_num: 15, job_read_num: 342,
    job_state: 1, job_istop: 1, ispublic: 1, admin: 'admin', company_name: '青蓝校园'
  },
  {
    job_id: 'j2', user_id: 'u-demo', company_id: 'cp2', job_name: 'Web 前端开发实习生',
    job_salary: '200元/天', job_num: '3', job_lable: '实习',
    job_content: '<p>参与公司官网与后台管理系统前端开发。技术栈：Vue / Element UI。</p><p>要求：计算机相关专业大三大四，每周到岗 4 天以上。</p>',
    job_createtime: t(5), job_updatetime: t(5), job_favour_num: 66, job_read_num: 987,
    job_state: 1, job_istop: 1, ispublic: 1, admin: 'admin', company_name: '南昌网络有限公司'
  },
  {
    job_id: 'j3', user_id: 'u-02', company_id: 'cp3', job_name: '晚自习辅导老师（兼职）',
    job_salary: '80元/次', job_num: '2', job_lable: '兼职',
    job_content: '<p>负责初中生晚自习作业辅导，周一至周五晚 19:00-21:00，工作地点在学校附近校区。</p><p>要求：有耐心，师范类专业优先。</p>',
    job_createtime: t(8), job_updatetime: t(8), job_favour_num: 8, job_read_num: 176,
    job_state: 1, job_istop: 0, ispublic: 1, admin: 'admin', company_name: '星火教育培训学校'
  },
  {
    job_id: 'j4', user_id: 'u-06', company_id: 'cp1', job_name: '校园摄影记者',
    job_salary: '150元/场', job_num: '2', job_lable: '校园大使',
    job_content: '<p>负责校内大型活动摄影摄像与新闻采写，出片后按篇结算。</p><p>要求：自备相机，有作品集优先。</p>',
    job_createtime: t(12), job_updatetime: t(12), job_favour_num: 21, job_read_num: 289,
    job_state: 1, job_istop: 0, ispublic: 1, admin: 'admin', company_name: '青蓝校园'
  }
]

// ---------------- 文章（article 表） ----------------
export const articles = [
  {
    article_id: 'a1', user_id: 'u-06', article_title: '关于图书馆新馆正式开放的通知',
    article_introduction: '图书馆新馆将于本周六正式开放，新增自习座位 1200 个，开放时间延长至 23:00。',
    article_lable: '校园新闻',
    article_content: '<p>各位同学：图书馆新馆已完成全部建设与验收工作，将于本周六（10 月 28 日）上午 8:00 正式开放。</p><p>新馆共五层，新增自习座位 1200 个，其中带电源插座座位 800 个；开放时间延长至每日 23:00。请同学们凭校园卡入馆，自觉遵守馆内秩序。</p>',
    article_createtime: t(1), article_updatetime: t(1), article_favour_num: 98, article_read_num: 2310,
    article_state: 1, article_istop: 1, ispublic: 1, admin: 'admin', nickname: '青蓝校园官方'
  },
  {
    article_id: 'a2', user_id: 'u-demo', article_title: '我的考研数学复习经验分享',
    article_introduction: '从 3 月到 12 月，数学复习三轮计划全记录，附踩坑提醒。',
    article_lable: '学习经验',
    article_content: '<p>很多同学问数学怎么复习，这里分享我的三轮计划：</p><p>第一轮（3-6 月）：教材 + 基础讲义，重点吃透概念与例题；</p><p>第二轮（7-9 月）：强化讲义 + 习题册，建立题型框架；</p><p>第三轮（10-12 月）：真题 + 模拟卷，掐时间成套做。</p><p>踩坑提醒：不要沉迷看视频，动手做题才是王道。</p>',
    article_createtime: t(7), article_updatetime: t(7), article_favour_num: 156, article_read_num: 3421,
    article_state: 1, article_istop: 0, ispublic: 1, admin: 'admin', nickname: '郭昂'
  },
  {
    article_id: 'a3', user_id: 'u-02', article_title: '校园周边美食探店：五食堂三楼',
    article_introduction: '人均 15 元的宝藏窗口合集，理工男也能吃出幸福感。',
    article_lable: '生活随笔',
    article_content: '<p>五食堂三楼这学期换了新窗口，亲测推荐：</p><p>1. 重庆小面（招牌豌杂面 12 元，加蛋 +1）；</p><p>2. 铁板炒饭（粒粒分明，量大管饱）；</p><p>3. 螺蛳粉（臭是臭了点，但真香）。</p>',
    article_createtime: t(14), article_updatetime: t(14), article_favour_num: 43, article_read_num: 876,
    article_state: 1, article_istop: 0, ispublic: 1, admin: 'admin', nickname: '李娜'
  },
  {
    article_id: 'a4', user_id: 'u-demo', article_title: 'Vue2 项目从 0 到 1 的完整踩坑记录',
    article_introduction: 'Vue 全家桶 + Element UI 开发校园信息平台的实战经验。',
    article_lable: '技术分享',
    article_content: '<p>本文记录使用 Vue2 + Element UI 开发校园信息交流平台的踩坑记录：</p><p>1. 路由守卫与登录态：token 存 localStorage，拦截器统一处理 401；</p><p>2. 富文本编辑器图片上传：自定义 image handler 走统一上传接口；</p><p>3. 权限控制：菜单按认证状态禁用，后端接口二次校验。</p>',
    article_createtime: t(20), article_updatetime: t(20), article_favour_num: 87, article_read_num: 1534,
    article_state: 1, article_istop: 0, ispublic: 1, admin: 'admin', nickname: '郭昂'
  }
]

// ---------------- 二手（oldstuff 表） ----------------
export const oldstuffs = [
  {
    oldstuff_id: 'o1', user_id: 'u-01', oldstuff_img: imgIpad, oldstuff_name: 'iPad 2019 32G',
    oldstuff_price: 1500, oldstuff_lable: '数码产品',
    oldstuff_content: '<p>自用 iPad 2019，32G，成色 9 成新，无磕碰，电池健康 89%。</p><p>附送保护壳和贴膜，仅限校内交易，可当面验机。</p>',
    createtime: t(2), updatetime: t(2), oldstuff_favour_num: 23, oldstuff_read_num: 431,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '账号1'
  },
  {
    oldstuff_id: 'o2', user_id: 'u-02', oldstuff_img: imgHeadphones, oldstuff_name: '索尼 WH-1000XM3 降噪耳机',
    oldstuff_price: 899, oldstuff_lable: '数码产品',
    oldstuff_content: '<p>索尼头戴式降噪耳机，自习必备神器。成色良好，耳罩无破损。</p><p>原价 2499，现 899 出，可小刀。</p>',
    createtime: t(4), updatetime: t(4), oldstuff_favour_num: 45, oldstuff_read_num: 1023,
    oldstuff_state: 1, oldstuff_istop: 1, ispublic: 1, admin: 'admin', nickname: '李娜'
  },
  {
    oldstuff_id: 'o3', user_id: 'u-03', oldstuff_img: imgBook, oldstuff_name: '高等数学（第七版）上下册',
    oldstuff_price: 20, oldstuff_lable: '书籍教材',
    oldstuff_content: '<p>高数上下册教材，无笔记，几乎全新。20 元两本打包出。</p><p>另有配套习题集可赠送。</p>',
    createtime: t(6), updatetime: t(6), oldstuff_favour_num: 5, oldstuff_read_num: 134,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '王强'
  },
  {
    oldstuff_id: 'o4', user_id: 'u-04', oldstuff_img: imgBadminton, oldstuff_name: '尤尼克斯羽毛球拍（单拍）',
    oldstuff_price: 180, oldstuff_lable: '体育器材',
    oldstuff_content: '<p>尤尼克斯 NR 系列羽毛球拍，磅数 24，手感好。附赠拍套。</p><p>因为换了新拍所以出掉，诚心要可小刀。</p>',
    createtime: t(8), updatetime: t(8), oldstuff_favour_num: 11, oldstuff_read_num: 245,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '陈静'
  },
  {
    oldstuff_id: 'o5', user_id: 'u-05', oldstuff_img: imgMemory, oldstuff_name: '闪迪 128G U 盘（USB3.0）',
    oldstuff_price: 45, oldstuff_lable: '数码产品',
    oldstuff_content: '<p>闪迪 128G U 盘，读写速度快，传输稳定。几乎全新。</p><p>45 元出，宿舍楼下交易。</p>',
    createtime: t(10), updatetime: t(10), oldstuff_favour_num: 3, oldstuff_read_num: 89,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '刘洋'
  },
  {
    oldstuff_id: 'o6', user_id: 'u-01', oldstuff_img: imgSsd, oldstuff_name: '三星 512G 固态硬盘（NVMe）',
    oldstuff_price: 260, oldstuff_lable: '数码产品',
    oldstuff_content: '<p>三星 PM981 512G 固态，读写 3000MB/s+，健康度 100%。</p><p>换了大容量所以出掉，装机升级的好选择。</p>',
    createtime: t(13), updatetime: t(13), oldstuff_favour_num: 17, oldstuff_read_num: 312,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '账号1'
  },
  {
    oldstuff_id: 'o7', user_id: 'u-02', oldstuff_img: imgProgramming, oldstuff_name: '《JavaScript 高级程序设计》第 4 版',
    oldstuff_price: 25, oldstuff_lable: '书籍教材',
    oldstuff_content: '<p>红宝书第四版，前端必读。书页有少量笔记，不影响阅读。</p><p>25 元出。</p>',
    createtime: t(15), updatetime: t(15), oldstuff_favour_num: 9, oldstuff_read_num: 178,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '李娜'
  },
  {
    oldstuff_id: 'o8', user_id: 'u-03', oldstuff_img: imgFitness, oldstuff_name: '瑜伽垫（加厚防滑）',
    oldstuff_price: 30, oldstuff_lable: '生活用品',
    oldstuff_content: '<p>加厚瑜伽垫，8mm 厚度，防滑无异味。用过几次，很干净。</p><p>30 元出，附送收纳绑带。</p>',
    createtime: t(18), updatetime: t(18), oldstuff_favour_num: 2, oldstuff_read_num: 67,
    oldstuff_state: 1, oldstuff_istop: 0, ispublic: 1, admin: 'admin', nickname: '王强'
  }
]

// ---------------- 评论 / 回复（comment / reply 表） ----------------
export const comments = [
  {
    comment_id: 'cm1', content_id: 'h1', user_id: 'u-02', comment_content: '<p>帮顶！建议去三食堂失物招领处登记一下，那里每周都会汇总。</p>',
    comment_createtime: t(1, 15), comment_favour_num: 6, comment_state: 1, comment_istop: 0, ispublic: 1,
    admin: 'admin', nickname: '李娜', avatar: imgMemory, qq: '200300400', mail: 'lina@haha.edu.cn', synopsis: '外国语学院大二学生',
    username: 'lina', realstate: 3,
    child: [
      {
        reply_id: 'r1', comment_id: 'cm1', user_id: 'u-01', reply_content: '<p>好的，谢谢提醒，我下午就去登记！</p>',
        tousernickname: '李娜', touserid: 'u-02', createtime: t(1, 16), reply_state: 1, reply_istop: 0, ispublic: 1,
        admin: 'admin', nickname: '账号1'
      }
    ]
  },
  {
    comment_id: 'cm2', content_id: 'h3', user_id: 'u-05', comment_content: '<p>5000 预算的话可以看看联想小新 Pro 14，屏幕好，性能也够用；或者加一点上拯救者 Y7000P。</p>',
    comment_createtime: t(7, 20), comment_favour_num: 23, comment_state: 1, comment_istop: 0, ispublic: 1,
    admin: 'admin', nickname: '刘洋', avatar: imgLibrary, qq: '500600700', mail: 'liuyang@haha.edu.cn', synopsis: '图书馆常驻人口',
    username: 'liuyang', realstate: 3,
    child: [
      {
        reply_id: 'r2', comment_id: 'cm2', user_id: 'u-demo', reply_content: '<p>感谢推荐！小新 Pro 14 我关注很久了，就它了。</p>',
        tousernickname: '刘洋', touserid: 'u-05', createtime: t(7, 21), reply_state: 1, reply_istop: 0, ispublic: 1,
        admin: 'admin', nickname: '郭昂'
      }
    ]
  },
  {
    comment_id: 'cm3', content_id: 'ac1', user_id: 'u-demo', comment_content: '<p>已经报名 400 米了，有没有一起的同学？</p>',
    comment_createtime: t(2, 12), comment_favour_num: 8, comment_state: 1, comment_istop: 0, ispublic: 1,
    admin: 'admin', nickname: '郭昂', avatar: imgPortrait, qq: '726647774', mail: 'demo@haha.edu.cn', synopsis: '信息工程学院大三',
    username: 'demo', realstate: 3,
    child: []
  }
]

// ---------------- 活动公告（announcement 表） ----------------
export const announcements = {
  ac1: [
    { announcement_id: 'an1', announcement_name: '报名截止时间提醒', announcement_content: '运动会报名将于本周五 18:00 截止，请未报名的同学抓紧时间。', announcement_createtime: t(2, 9) },
    { announcement_id: 'an2', announcement_name: '赛程安排已发布', announcement_content: '详细赛程安排已上传，请各参赛选手提前 30 分钟到检录处检录。', announcement_createtime: t(1, 15) }
  ],
  ac2: [
    { announcement_id: 'an3', announcement_name: '会议号已生成', announcement_content: '腾讯会议号：123-456-789，请提前 10 分钟进入直播间。', announcement_createtime: t(1, 10) }
  ]
}

// ---------------- 报名（joins 表） ----------------
export const joins = [
  { join_id: 'jn1', type: 'activitycontent', user_id: 'u-demo', name: '郭昂', describe: '报名 400 米', content_id: 'ac1', jions_createtime: t(2, 12) },
  { join_id: 'jn2', type: 'activitycontent', user_id: 'u-01', name: '账号1', describe: '报名 100 米', content_id: 'ac1', jions_createtime: t(2, 10) },
  { join_id: 'jn3', type: 'oldstuffcontent', user_id: 'u-demo', name: '1500', describe: '13800000001', content_id: 'o2', jions_createtime: t(1, 9) }
]

// ---------------- 消息通知（notice 表） ----------------
export const notices = [
  {
    notice_id: 'n1', user_from: 'u-02', user_to: 'u-demo', action: '回复了你的评论', content_id: 'cm1',
    router: 'helpcontent', createtime: t(0, 9), state: 0, content_name: '你的评论', nickname: '李娜'
  },
  {
    notice_id: 'n2', user_from: 'u-06', user_to: 'u-demo', action: '你报名的活动发布了新公告', content_id: 'ac1',
    router: 'activitycontent', createtime: t(1, 15), state: 0, content_name: '秋季校园运动会报名开启', nickname: '青蓝校园官方'
  },
  {
    notice_id: 'n3', user_from: 'u-05', user_to: 'u-demo', action: '回复了你的评论', content_id: 'cm2',
    router: 'helpcontent', createtime: t(2, 8), state: 1, content_name: '你的评论', nickname: '刘洋'
  }
]

// ---------------- 客服工单（fankui/jubao/shensu 表） ----------------
export const kefus = {
  fankui: [
    { fankui_id: 'fk1', fankui_content: '希望增加一个二手商品搜索功能，现在只能按分类浏览。', fankui_user: 'lina@haha.edu.cn', fankui_createtime: t(3), fankui_state: 0, admin: '' }
  ],
  jubao: [
    {
      jubao_id: 'jb1', jubao_content: '该账号发布虚假兼职信息，声称日结 500 元，疑似诈骗。', jubao_user: 'wangqiang',
      jubao_img: [imgProgramming], jubao_url: 'http://localhost:8090/#/jobcontent/j1',
      jubao_createtime: t(4), jubao_state: 0, admin: '', result: ''
    }
  ],
  shensu: [
    { shensu_id: 'ss1', shensu_content: '我的账号被误封了，我发布的内容都是真实合法的，请管理员复查。', shensu_user: 'wangqiang', shensu_jubao_id: 'jb1', shensu_createtime: t(2), shensu_state: 0, admin: '' }
  ]
}

// 追加我的内容（个人中心用）
export const myData = {
  helps: helps.filter((h) => h.user_id === 'u-demo'),
  activities: [activities[0]],
  oldstuffs: [],
  articles: [articles[1], articles[3]],
  company: companies[1],
  jobs: [jobs[1]]
}

export { imgBadminton, imgBook, imgFitness, imgFootball, imgHeadphones, imgIpad, imgJavascript, imgLibrary, imgMathematics, imgMemory, imgPhoto, imgPortrait, imgProgramming, imgSsd }
